module.exports = __webpack_public_path__ + "img/img1.b3eff2e0.png";